import { render, staticRenderFns } from "./SubdistributorList.vue?vue&type=template&id=7bd51ee8"
import script from "./SubdistributorList.vue?vue&type=script&lang=js"
export * from "./SubdistributorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports